import React from "react";
import { InputGroupDisable } from "@funded-here-interface/common";

function camelCaseToNormalCase(str: string) {
  // Convert camelCase to "Camel Case"
  return str
    .replace(/([A-Z])/g, " $1")
    .trim()
    .split(" ")
    .map((word, idx) => {
      if (word.toLowerCase() === "of") return "of";
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

interface GenericSectionProps {
  title: string;
  data: Record<string, any>;
  excludeKeys?: string[];
}

interface UserSignupDetailsProps {
  accountType: string;
  email: string;
  firstName: string;
  lastName: string;
  companyName: string;
  countryCode: string;
}

interface UserDetailsProps {
  firstName: string;
  lastName: string;
  gender: string;
  mobileCountryCode: string;
  mobileNumber: string;
  employmentStatus: string;
  employmentIndustry: string;
  employmentPosition: string;
  dateOfBirth: string;
  countryOfBirth: string;
  residentialAddress: string;
  postalCode: string;
  countryCode: string;
  nationality: string;
  identificationType: string;
  identificationNumber: string;
  issueDate: string;
  expiryDate: string;
}

interface CompanyDetailsProps {
  companyName: string;
  businessType: string;
  registrationNumber: string;
  incorporationDate: string;
  companyAddress: string;
  companyPostalCode: string;
  city: string;
  state: string;
  countryOfIncorporation: string;
  countryOfOperation: string;
}

interface CustomerDueDiligenceProps {
  customerBusinessWebsite: string;
  customerBusinessDescription: string;
  entityType: string;
  ownershipStructureLayers: string;
  countryOfIncorporation: string;
  countryOfOperation: string;
  paymentModes: string;
  onboardingMode: string;
  productServiceComplexity: string;
  companyAddress: string;
  isPermanentPlaceOfBusiness: string;
  siteVisitPerformedAtAddress: string;
  isPremisesInLineWithBusiness: string;
  isHigherRiskEntityType: string;
  higherRiskEntityType: string;
  productUsage: string;
  purposeOfAccountOpening: string;
  isMakingPaymentsToIndividuals: string;
  makingPaymentsToIndividualsDescription: string;
  isMakingThirdPartyPayments: string;
  sourceOfFunds: string;
  primaryTransactingCountriesInbound: string;
  primaryTransactingCountriesOutbound: string;
  topCounterPartiesInbound: string;
  topCounterPartiesOutbound: string;
  anticipatedVolumeMonthlyTransactionsCountInbound: string;
  anticipatedVolumeMonthlyTransactionsCountOutbound: string;
  anticipatedValueMonthlyTransactionsInbound: string | number;
  anticipatedValueMonthlyTransactionsOutbound: string | number;
  currencyPairsInbound: string;
  currencyPairsOutbound: string;
}

const GenericSection: React.FC<GenericSectionProps> = ({
  title,
  data,
  excludeKeys = [],
}) => (
  <>
    <span style={{ color: "black" }}>
      <b>
        <u>{title}</u>
      </b>
    </span>
    {Object.keys(data)
      .filter((key) => !excludeKeys.includes(key))
      .map((key) => (
        <InputGroupDisable
          key={key}
          labelText={camelCaseToNormalCase(key)}
          id={key}
          value={data[key] ?? ""}
        />
      ))}
  </>
);

const UserSignUpDetails: React.FC<UserSignupDetailsProps> = (props) => (
  <GenericSection title="User Sign-Up Details" data={props} />
);

const UserDetails: React.FC<UserDetailsProps> = (props) => (
  <GenericSection title="User Details" data={props} />
);

const CompanyDetails: React.FC<CompanyDetailsProps> = (props) => (
  <GenericSection title="Company Details" data={props} />
);

const CustomerDueDiligence: React.FC<CustomerDueDiligenceProps> = (props) => (
  <GenericSection title="Customer Due Diligence Details" data={props} />
);

const Forms = {
  UserSignUpDetails,
  UserDetails,
  CompanyDetails,
  CustomerDueDiligence,
};

export default Forms;
